// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j4yd","col":"styles_col__Uwoa6"};